import _ from 'underscore';
import URI from 'urijs';
import { Router } from '@bingads-webui/router';

import { removeBasename } from './paths';

/**
 * The options for navigate function
 * @typedef {Object} Options
 * @property {Object} params adding query params to the url
 * @property {Object} state adding state to the history object to pass objects during navigation, used for history only
 * @property {boolean} formatSpaPath true by default, to format the url as a spa format or false to keep the same url even if it is absolute
 */

/**
 * Function to navigate using the react's router history object if available and if the path exists in route-configuration, otherwise default server-side navigation
 * @param {String} url the url in a string format
 * @param {Options} options options for adding parameters
 * @param {Object} history the react's router history object
 * @returns {void}
 */
export function navigate(url, options = {}, history = {}) {
  const { params = {}, state } = options;
  const uri = URI(url).setSearch(params);
  if (_.has(history, 'push')) {
    // if the url is absolute and its path starts with the basename or if the url is relative, then it means it's an spa path
    if ((uri.is('absolute') && uri.path().toLowerCase().startsWith(history.basename.toLowerCase())) || uri.is('relative')) {
      const pathname = removeBasename(uri.path(), history.basename);
      history.push({
        pathname,
        search: uri.search(),
        state,
      });
    } else {
      history.push(uri.toString());
    }
  } else {
    Router.navigate(uri.toString());
  }
}
